export default __webpack_public_path__ + "static/media/Rto.7fab7f01.svg";